import { useEffect } from 'react'

let initLocation = null
const clickQueue = []
const datalayerModulesLoaded = {}
const datalayerModules = { addLinkNameToDataLayer: (...args) => clickQueue.push({ args, initLocation }) }
let globalDataLayerLoaded = false

const setDatalayerModules = updateGlobalState => {
  if (!globalDataLayerLoaded) {
    globalDataLayerLoaded = true
    Object.keys(datalayerModulesLoaded).forEach(key => (datalayerModules[key] = datalayerModulesLoaded[key]))
    clickQueue.forEach(({ args, initLocation }) => addLinkNameToDataLayer(...args, initLocation))
    updateGlobalState({ dataLayerLoaded: true })
  }
}

export const addLinkNameToDataLayer = (...args) => datalayerModules.addLinkNameToDataLayer(...args)

// loads datalayer when page is ready and sets modules when analytics script is fully and successfully loaded
export const useDataLayerModules = (location, globalState, updateGlobalState) => {
  const { pageReady, analyticsReady, dataLayerLoaded } = globalState
  initLocation = location

  useEffect(() => {
    if (analyticsReady) {
      if (datalayerModulesLoaded.loaded) setDatalayerModules(updateGlobalState)
      else datalayerModulesLoaded.analytics = true
    }
  }, [analyticsReady, updateGlobalState])

  useEffect(() => {
    if (!dataLayerLoaded && !globalDataLayerLoaded && pageReady) {
      import('../analytics/datalayer').then(modules => {
        Object.keys(modules).forEach(key => (datalayerModulesLoaded[key] = modules[key]))
        if (datalayerModulesLoaded.analytics) setDatalayerModules(updateGlobalState)
        else datalayerModulesLoaded.loaded = true
      })
    }
  }, [pageReady, dataLayerLoaded, updateGlobalState])
  return datalayerModules
}
